import React, { useEffect, useState } from 'react';
import { SellerRow, Table } from './style';
import { useDispatch, useSelector } from 'react-redux';
import { getOrders, getPageStats } from './redux/selectors';
import { get_orders } from './redux/reducer';
import Pagination from '@design-system/Pagination';
import { Modal } from '@design-system/Modal';
import moment from 'moment';
import commaNumber from 'comma-number';
import OrderReview from './components/orderReview';
import { getSellers } from '@app/sellers/redux/selectors';
import { Link } from 'react-router-dom';

const TransactionHistory = () => {
  const head = ['transaction ID', 'date', 'seller', 'price', ''];
  const dispatch = useDispatch();
  const orders = useSelector(getOrders);
  const [show, setShow] = useState(false);
  const pageStats = useSelector(getPageStats);
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [review, setReview] = useState({});
  const seller = useSelector(getSellers);

  useEffect(() => {
    dispatch(
      get_orders({
        page: currentPage,
        limit: pageSize,
        partner: seller._id,
      }),
    );
  }, [dispatch, pageSize, currentPage, seller]);

  const handlePageChange = () => {
    setCurrentPage((currentPage) => currentPage + 1);
  };

  const handlePreviousChange = () => {
    setCurrentPage((currentPage) => currentPage - 1);
  };

  const handlePageSizeChange = (page) => {
    setCurrentPage(page);
  };

  const open = (data) => {
    setReview(data);
    setShow(!show);
  };

  const close = () => {
    setReview({});
    setShow(!show);
  };

  return (
    <div>
      <Modal show={show} close={close}>
        <OrderReview review={review} close={close} />
      </Modal>
      <Table>
        <table>
          <thead>
            <tr>
              {head.map((data, index) => (
                <th key={index}>{data}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {orders?.map((data) => (
              <tr key={data._id}>
                <td className="id">{data.order_no}</td>
                <td className="date">
                  {moment(data.created_at).format('MMM DD, YYYY')}
                </td>
                <td>
                  <SellerRow>
                    <img src={seller?.user?.photo_url} alt={seller?.business_name} />
                    <div>
                      <p className="seller_name">{seller?.business_name}</p>
                      <div>
                        {data?.order_review?._id ? (
                          <h4 onClick={() => open(data)}>Review Seller</h4>
                        ) : (
                          <h4 className="non_active">Review Seller</h4>
                        )}
                      </div>
                    </div>
                  </SellerRow>
                </td>

                <td className="price">
                  {data.amount_paid.currency.symbol}
                  {commaNumber(data.amount_paid.value)}
                </td>
                <td>
                  <Link to={`/order/${data._id}`}>View</Link>
                </td>

                {/* <td className="link">Buy again</td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </Table>
      <Pagination
        handlePageChange={handlePageChange}
        handlePreviousChange={handlePreviousChange}
        onChangePageSize={handlePageSizeChange}
        currentPage={currentPage}
        pageSize={pageSize}
        itemsCount={pageStats.docs}
      />
    </div>
  );
};

export default TransactionHistory;
